<template>
  <div class="modal new-contact animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('contact_modal.new_contact') }}</p>
      </header>
      <section class="modal-card-body form">
        <div class="float-label full remove-padding-left">
          <input type="text" name="name" id="name" v-validate="'required'" v-model.trim="contact.name" @keyup.enter="saveContact()" autofocus="true" required>
          <label for="name">{{ $t('contact_modal.name_input.label') }}</label>
          <span class="help-block" v-if="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
        <div class="float-label half remove-padding-left">
          <input type="email" name="email" id="email" v-validate="'required|email|duplicate_contact'" data-vv-validate-on="blur" v-model.trim="contact.email" @keyup.enter="saveContact()" required>
          <label for="email">{{ $t('contact_modal.email_input.label') }}</label>
          <span class="help-block" v-if="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
        <div class="float-label half remove-padding-right">
          <input type="text" name="company" id="company" v-validate="'required'" v-model.trim="contact.company" @keyup.enter="saveContact()" required>
          <label for="company">{{ $t('contact_modal.company_input.label') }}</label>
          <span class="help-block" v-if="errors.has('company')">{{ errors.first('company') }}</span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary is-large"
          :disabled="!contact.name || !contact.email || !contact.company || errors.any()"
          @click="saveContact()">{{ $t('contact_modal.create_contact') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';
import { Validator } from 'vee-validate';

export default {
  mixins: [API],
  data() {
    return {
      Events: window.Events,
      contact: {
        name: '',
        email: '',
        company: ''
      },
      contacts: []
    }
  },
  beforeMount() {
    this.api().fetchTeamContacts()
      .then(contacts => this.contacts = contacts);

    Validator.extend('duplicate_contact', {
      getMessage: (field, args) => {
        return this.$t('contact_modal.contact_error_duplicate');
      },
      validate: (value, args)  => {
        return !_.some(this.contacts, (contact) => { return contact.email === value; });
      }
    });
  },
  methods: {
    closeModal() {
      this.Events.$emit('modalClose', 'newContactModal');
      this.cleanFields();
    },
    saveContact() {
      this.$validator.validateAll().then(result => {
        if (!result) { return; }
        this.api().createContact(this.contact)
          .then(response => {
            (new Notyf()).confirm(this.$t('contact_modal.contact_created'));
            this.closeModal();
          })
          .catch(error => {
            (new Notyf()).alert(this.$t('contact_modal.contact_error'));
          });
      }).catch(() => {
        return;
      });
    },
    cleanFields() {
      setTimeout(() => {
        this.contact.name = null;
        this.contact.email = null;
        this.contact.company = null;
        this.$validator.clean();
      }, 15);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.form {
  margin: 2em;
  overflow: visible;
}
.full { width: 100%; }
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
.modal-background {
  background: hsla(0,0%,100%,0.3);
}

</style>



// WEBPACK FOOTER //
// new-contact-modal.vue?4dfc43be